import { gql } from 'graphql-request'

export default gql`
  query getMedicalEquipmentAddresses($provider: String) {
    applications {
      medicalEquipment {
        addresses(provider: $provider) {
          success
          addresses {
            id
            label
          }
        }
      }
    }
  }
`
